import { Component, OnInit } from '@angular/core';
import { ErrorService } from '../../../tools/error.service';
import { IxellAPIService, IPlanningGestionRDV, IPlanningHisto, IPlanningListV1, StatusRDV } from '../../../tools/api.service';
import { HeaderService } from '../../../tools/header.service';
import { Language } from '../../../entities/Language';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from '../../../entities/Constants';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Utils } from '../../../tools/utils';
import * as _moment from 'moment';

@Component({
    selector: 'app-planning-gestion',
    templateUrl: './planning-gestion.component.html',
    styleUrls: ['./planning-gestion.component.scss']
})

export class PlanningGestionComponent implements OnInit {
    private langue: Language;
    private langueSub: any;
    private getListSub: any;
    private getHotlinerSub: any;
    private getStatusSub: any;
    private cancelSub: any;
    private updateSub: any;

    displayedColumns = ["rdvID_G", "statusRDV_G", "dateRDV_G", "hotliner", "duration", "typeIntervention", "ctc_G", "ctcPhone_G", "user", "action"];
    listRdvSource: any;
    listRdv: IPlanningGestionRDV[] = [];

    listHotliner: IPlanningListV1[] = [];
    statusRDV: StatusRDV;
    languageCTC: string;

    showCancelModal: boolean = false;
    currentRdv: IPlanningGestionRDV = new IPlanningGestionRDV();
    newRdv: IPlanningGestionRDV = new IPlanningGestionRDV();

    updateRdvForm = new UntypedFormGroup({
        date: new UntypedFormControl('', [Validators.required]),
        start: new UntypedFormControl('', [Validators.required]),
        end: new UntypedFormControl('', [Validators.required]),
        hotliner: new UntypedFormControl('', [Validators.required])
    });

    invalidForm: boolean = false;

    constructor(private headerService: HeaderService, private api: IxellAPIService, private errorService: ErrorService, private _adapter: DateAdapter<any>, private _snackBar: MatSnackBar) { }

    ngOnInit() {
        this.headerService.changeTitle("support.supportAssistance");
        this.headerService.changeCanBack(true);
        this._adapter.setLocale('fr');
        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            this.langue = langue;
        }, error => {
            console.log(error);
            if (this.langueSub != null) this.langueSub.unsubscribe();
        });

        this.getHotlinerList();

        window.setTimeout(() => {
            this.getHisto();
        }, 500);
    }

    getHotlinerList() {
        this.getHotlinerSub = this.api.getHotlinerList().subscribe(data => {
            if (data != null) {
                data.forEach(element => {
                    this.listHotliner.push(element);
                });
            }
            if (this.getHotlinerSub != null) this.getHotlinerSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getHotlinerList", new Date().toString());
            if (this.getHotlinerSub != null) this.getHotlinerSub.unsubscribe();
        });
    }


    getHisto() {
        this.listRdv = [];
        this.getListSub = this.api.getListRDVbyHotliner().subscribe(data => {

            console.log(data);

            if (data) {
                data.forEach(element => {

                    //element.startDate = new Date(element.startDate.setHours(element.startDate.getHours() - 2));

                    //var startDateUTC = new Date(Date.UTC(element.startDate.getFullYear(), element.startDate.getMonth(), element.startDate.getDate(), element.startDate.getHours(), element.startDate.getMinutes()));
                    //var endDateUTC = new Date(Date.UTC(element.endDate.getFullYear(), element.endDate.getMonth(), element.endDate.getDate(), element.endDate.getHours(), element.endDate.getMinutes()));
                    //element.startDate = startDateUTC;
                    //element.endDate = endDateUTC;
                    if (element.startDate > new Date() && element.status == 1 && element.wpRdvID != null) element.canCancel = true;
                    else element.canCancel = false;
                    this.listRdv.push(element);
                    this.listRdvSource = new MatTableDataSource(this.listRdv);
                });
            }
            if (this.getListSub != null) this.getListSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getListRDVbyHotliner", new Date().toString());
            if (this.getListSub != null) this.getListSub.unsubscribe();
        });
    }

    closeModal(name: string) {
        let Modal = document.getElementById(name);
        Modal.style.display = "none";
    }

    openModal(name: string) {
        let Modal = document.getElementById(name);
        Modal.style.display = "block";
    }

    checkStatus(id: number) {
        this.statusRDV = 0;
        this.getStatusSub = this.api.getStatusRDV(id).subscribe(data => {
            this.statusRDV = data.valueOf();
            if (this.getStatusSub != null) this.getStatusSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getStatus", new Date().toString());
            if (this.getStatusSub != null) this.getStatusSub.unsubscribe();
        });
    }

    // Ouverture de la modale pour annuler le RDV
    cancel(id: number) {
        this.currentRdv = new IPlanningGestionRDV();
        this.currentRdv = this.listRdv.find(r => r.rdvID == id);

        this.checkStatus(id);

        window.setTimeout(() => {
            if (this.statusRDV != StatusRDV.TRANSMITTED) {
                this.openSnackBar("Le RDV a déjà été annulé", "OK");
                this.getHisto();
            }
            else {
                this.showCancelModal = true;
                this.openModal("cancelModal");
            }
        }, 1000);
    }

    // Validation de l'annulation
    validCancel(res: boolean) {
        this.closeModal("cancelModal");
        var cancelOK = false;
        if (res == true) {
            this.openModal("loadingModal");
            this.cancelSub = this.api.cancelRDV(this.currentRdv.rdvID, this.currentRdv.wpRdvID, this.currentRdv.ctc_Language, this.currentRdv.ctc_Mail, this.currentRdv.ctc_Country).subscribe(data => {
                cancelOK = data;
                if (data) {
                    this.closeModal("loadingModal");
                    this.openModal("confirmCancelModal");
                    this.getHisto();
                }
                else {
                    this.closeModal("loadingModal");
                    this.openModal("errorModal");
                }
                if (this.cancelSub != null) this.cancelSub.unsubscribe();
            }, error => {
                this.closeModal("loadingModal");
                this.openModal("errorModal");
                this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "cancelRDV (gestion hotline)", new Date().toString());
                if (this.cancelSub != null) this.cancelSub.unsubscribe();
            });
        }
    }

    // Ouverture de la modale pour modifier le RDV
    update(id: number) {
        this.languageCTC = "";
        this.currentRdv = new IPlanningGestionRDV();
        this.currentRdv = this.listRdv.find(r => r.rdvID == id);

        this.checkStatus(id);

        window.setTimeout(() => {
            if (this.statusRDV != StatusRDV.TRANSMITTED) {
                this.openSnackBar("Le RDV a déjà été annulé", "OK");
                this.getHisto();
            }
            else {
                var dateValue = new Date(new Date(this.currentRdv.startDate).getTime());

                var startHour = (this.currentRdv.startDate.getHours() < 10 ? "0" : "") + this.currentRdv.startDate.getHours();
                var startMin = (this.currentRdv.startDate.getMinutes() < 10 ? "0" : "") + this.currentRdv.startDate.getMinutes();
                var startValue = startHour + ':' + startMin;

                var endHour = (this.currentRdv.endDate.getHours() < 10 ? "0" : "") + this.currentRdv.endDate.getHours();
                var endMin = (this.currentRdv.endDate.getMinutes() < 10 ? "0" : "") + this.currentRdv.endDate.getMinutes();
                var endValue = endHour + ':' + endMin;

                this.updateRdvForm.setValue({
                    date: dateValue,
                    start: startValue,
                    end: endValue,
                    hotliner: this.currentRdv.loginHotliner
                });

                switch (this.currentRdv.ctc_Language) {
                    case "Dutch": this.languageCTC = "Néerlandais"; break;
                    case "English": this.languageCTC = "Anglais"; break;
                    case "French": this.languageCTC = "Français"; break;
                    case "German": this.languageCTC = "Allemand"; break;
                    case "Italian": this.languageCTC = "Italien"; break;
                    case "Polish": this.languageCTC = "Anglais (Polonais)"; break;
                    case "Portuguese": this.languageCTC = "Portugais"; break;
                    case "Romanian": this.languageCTC = "Roumain"; break;
                    case "Spanish": this.languageCTC = "Espagnol"; break;
                    case "Turkish": this.languageCTC = "Anglais (Turc)"; break;
                }

                this.showCancelModal = true;
                this.openModal("updateModal");
                this.newRdv = new IPlanningGestionRDV();
            }
        }, 1000);
    }

    // Modification auto de l'heure de fin
    changeEnd() {
        if (!Utils.IsNullOrWhiteSpace(this.updateRdvForm.value["start"])) {
            var date = new Date(this.updateRdvForm.value["date"]);
            var startTime = this.updateRdvForm.value["start"].split(':');
            var newStartDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startTime[0], startTime[1]);
            var newEndDate = _moment(newStartDate).add(this.currentRdv.duration, 'm').toDate();
            var endHour = (newEndDate.getHours() < 10 ? "0" : "") + newEndDate.getHours();
            var endMin = (newEndDate.getMinutes() < 10 ? "0" : "") + newEndDate.getMinutes();
            var endValue = endHour + ':' + endMin;
            this.updateRdvForm.controls["end"].setValue(endValue);
        }
    }

    // Validation de la modification
    validUpdate(res: boolean) {
        if (res == true) {

            var date = new Date(this.updateRdvForm.value["date"]);
            var startTime = this.updateRdvForm.value["start"].split(':');
            var endTime = this.updateRdvForm.value["end"].split(':');

            var newStartDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startTime[0], startTime[1]);
            var newEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), endTime[0], endTime[1]);

            console.log("date", date);
            console.log("startTime", startTime);
            console.log("endTime", endTime);
            console.log("newStartDate", newStartDate);
            console.log("newEndDate", newEndDate);

            if (this.updateRdvForm.status == "VALID") {
                if (newStartDate < newEndDate) {
                    this.invalidForm = false;

                    // appel de l'update
                    this.newRdv.rdvID = this.currentRdv.rdvID;
                    this.newRdv.wpRdvID = this.currentRdv.wpRdvID;
                    this.newRdv.loginHotliner = this.updateRdvForm.value["hotliner"].trim();
                    this.newRdv.startDate = newStartDate;
                    this.newRdv.endDate = newEndDate;
                    this.newRdv.ctc_Language = this.currentRdv.ctc_Language;
                    this.newRdv.ctc_Mail = this.currentRdv.ctc_Mail;
                    this.newRdv.ctc_Country = this.currentRdv.ctc_Country;
                    this.newRdv.mailHotliner = this.currentRdv.mailHotliner;
                    this.newRdv.duration = this.currentRdv.duration;
                    this.newRdv.typeIntervention = this.currentRdv.typeIntervention;
                    this.newRdv.user_SocialReason = this.currentRdv.user_SocialReason;
                    this.newRdv.user_Name = this.currentRdv.user_Name;
                    this.newRdv.user_Firstname = this.currentRdv.user_Firstname;
                    this.newRdv.user_PostalCode = this.currentRdv.user_PostalCode;
                    this.newRdv.user_City = this.currentRdv.user_City;
                    var changeDate = true;
                    var changeStartDate = true;
                    var changeEndDate = true;
                    if ((newStartDate.toString() === this.currentRdv.startDate.toString()) && (newEndDate.toString() === this.currentRdv.endDate.toString())) {
                        changeDate = false;
                    }
                    if (newStartDate.toString() === this.currentRdv.startDate.toString()) {
                        changeStartDate = false;
                    }
                    if (newEndDate.toString() === this.currentRdv.endDate.toString()) {
                        changeEndDate = false;
                    }

                    this.closeModal("updateModal");
                    this.openModal("loadingModal");

                    this.updateSub = this.api.changeRDV(this.newRdv).subscribe(data => {
                        this.closeModal("loadingModal");
                        switch (data) {
                            case 0: // aucune modification
                                console.log("Aucune modification");
                                break;
                            case 1: // modification OK
                                this.getHisto();
                                if (changeDate) {
                                    if (changeStartDate) {
                                        this.openModal("confirmUpdateStartDateModal");
                                    }
                                    else {
                                        this.openModal("confirmUpdateEndDateModal");
                                    }
                                }
                                else {
                                    this.openModal("confirmUpdateLoginModal");
                                }
                                break;
                            case 2: // erreur lors de la modification
                                this.openModal("errorModal");
                                break;
                        }
                        if (this.updateSub != null) this.updateSub.unsubscribe();
                    }, error => {
                        this.closeModal("loadingModal");
                        this.openModal("errorModal");
                        this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "updateRDV", new Date().toString());
                        if (this.updateSub != null) this.updateSub.unsubscribe();
                    });
                }
                else {
                    this.invalidForm = true;
                }
            }
            else {
                this.updateRdvForm.markAllAsTouched();
            }
        }
        else {
            this.closeModal("updateModal");
        }
    }

    closeError() {
        this.closeModal("errorModal");
        this.getHisto();
    }

    sortScale(sort: Sort, status: string) {
        var data = this.listRdv;
        Constants.sortScale(sort, status, data);
        this.listRdv = data.slice();
        this.listRdvSource = new MatTableDataSource(this.listRdv);
    }

    refresh() {
        this.getHisto();
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['blue-snackbar']
        });
    }

}
